import { observer } from 'mobx-react-lite';
/* tslint:disable:jsx-no-lambda WI:47635 */
import { ControlIcons } from 'owa-control-icons';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { trace } from 'owa-trace';
import { IconButton } from 'office-ui-fabric-react/lib/Button';

const styles = require('../styles/videoPlayerStyles.scss');

interface BingVideoPlayerProps {
    videoPlayerHtml: string;
    onClose: () => void;
}

const BingVideoPlayer = observer(function BingVideoPlayer(props: BingVideoPlayerProps) {
    const onDismissVideoPlayer = (evt: React.MouseEvent<unknown>) => {
        trace.info('Dismiss Video Player');
        evt.stopPropagation();
        props.onClose();
    };
    const setAndResizeVideoPlayerContent = (videoPlayer: HTMLDivElement) => {
        if (videoPlayer) {
            // The videoPlayerHtml is not user content. It is provided to us by a call to OWS' (which gets it from a Bing service) where it has already been sanitized.
            // tslint:disable-next-line:no-inner-html
            videoPlayer.innerHTML = props.videoPlayerHtml;
            let iframes = videoPlayer.querySelectorAll('iframe');
            if (iframes && iframes.length === 1) {
                iframes[0].setAttribute('width', '800px');
                iframes[0].setAttribute('height', '530px');
            }
        }
    };
    return (
        <div className={styles.videoPlayerBackground} onClick={onDismissVideoPlayer}>
            <div className={styles.videoContainer} onClick={onPlayerClicked}>
                <IconButton
                    className={styles.closeButtonIcon}
                    iconProps={{ iconName: ControlIcons.ChromeClose }}
                    onClick={onDismissVideoPlayer}
                />
                <div ref={setAndResizeVideoPlayerContent} />
            </div>
        </div>
    );
});

let videoPlayerDiv = null;
export default function showVideoPlayer(videoPlayerHtml: string): void {
    if (!videoPlayerDiv) {
        // As we can have only one video player open at a time so we only create the
        // DOM element once and reuse that.
        videoPlayerDiv = document.createElement('div');
        videoPlayerDiv.id = 'BingVideoPlayer';
        document.body.appendChild(videoPlayerDiv);
    }

    ReactDOM.render(
        <React.StrictMode>
            <BingVideoPlayer
                videoPlayerHtml={videoPlayerHtml}
                onClose={() => {
                    ReactDOM.unmountComponentAtNode(videoPlayerDiv);
                }}
            />
        </React.StrictMode>,
        videoPlayerDiv
    );
}

function onPlayerClicked(evt: React.MouseEvent<unknown>) {
    evt.stopPropagation();
}
